import { values } from "lodash";
import { ISelectOption } from "../common/typings";

interface IPartnerTypesMap {
  [key: string]: ISelectOption;
}
export const partnerTypes: IPartnerTypesMap = {
  PASYDY: {
    value: "PASYDY",
    label: "Pasydy",
  },
};

export const partnerTypeOptions = values(partnerTypes);
